<template>
	<div class="comp-c-tools">
		<div class="comp-c-tools-container">
			<div class="comp-c-tools-items">
				<div class="comp-c-tools-item" v-if="isShow('emoji')" @click="toolsClick('emoji')" title="表情">
					<span class="comp-c-tools-emoji"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('image')"  @click="toolsClick('image')" title="图片">
					<span class="comp-c-tools-image"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('video')"  @click="toolsClick('video')" title="视频">
					<span class="comp-c-tools-video"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('file')"  @click="toolsClick('file')" title="文件">
					<span class="comp-c-tools-file"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('audio')" @click="toolsClick('audio')" title="语音">
					<span class="comp-c-tools-audio"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('history')" @click="toolsClick('history')" title="历史记录">
					<span class="comp-c-tools-history"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('shareMsg')" @click="toolsClick('shareMsg')" title="转发">
					<span class="comp-c-tools-sharemsg"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('location')" @click="toolsClick('location')" title="发送位置">
					<span class="comp-c-tools-location"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('redPacket')" @click="toolsClick('redPacket')" title="商户红包">
					<span class="comp-c-tools-redpacket"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('aite')" @click="toolsClick('aite')" title="@群成员">
					<span class="comp-c-tools-aite"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('order')" @click="toolsClick('order')" title="快捷下单">
					<span class="comp-c-tools-order"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('game')" @click="toolsClick('game')" title="游戏">
					<span class="comp-c-tools-game"></span>
				</div>
				<div class="comp-c-tools-item" v-if="isShow('customer_expansion')" @click="toolsClick('customer_expansion')" title="客户扩展信息">
					<span class="comp-c-tools-customer-expansion"></span>
				</div>
			</div>
			<div class="comp-c-tools-other">
				<div class="comp-c-tools-o-item" v-if="isShow('fans_transfer')" @click="toolsClick('fans_transfer')" title="转移聊天">
					<span class="comp-c-tools-share"></span>
				</div>
				<!-- <div class="comp-c-tools-o-item" v-if="isShow('circle')" @click="toolsClick('circle')" title="朋友圈">
					<span class="comp-c-tools-circle"></span>
				</div> -->
				<div class="comp-c-tools-o-item" v-if="isShow('order2')" @click="toolsClick('order2')" title="快捷下单">
					<span class="comp-c-tools-order"></span>
				</div>
			</div>
		</div>
		<div class="comp-c-tools-emoji-box" v-if="currentTools == 'emoji'">
			<emoji @emoji-call='emojiCall($event)' :showMore="true"></emoji>
		</div>
		<div class="comp-c-tools-image-box" v-else-if="currentTools == 'image'">
			<oss-img-uploader uploadType='2' uploadDir="chatting" key='chat-tools-u1' @oss-upload-call="ossUploadCall($event,'image')"></oss-img-uploader>
		</div>
		<div class="comp-c-tools-video-box" v-else-if="currentTools == 'video'">
			<oss-img-uploader uploadType='3' uploadDir="chatting" key='chat-tools-u2' @oss-upload-call="ossUploadCall($event,'video')"></oss-img-uploader>
		</div>
		<div class="comp-c-tools-file-box" v-else-if="currentTools == 'file'">
			<oss-img-uploader uploadType='5' uploadDir="chatting" key='chat-tools-u3' :backDetail="true" @oss-upload-call="ossUploadCall($event,'file')"></oss-img-uploader>
		</div>
		<div class="comp-c-tools-audio-box" v-else-if="currentTools == 'audio'">
			<oss-img-uploader uploadType='7' uploadDir="chatting" key='chat-tools-u4' :backDetail="true" @oss-upload-call="ossUploadCall($event,'audio')"></oss-img-uploader>
		</div>
		<div class="comp-c-tools-sharemsg-box" v-else-if="currentTools == 'shareMsg'">
			<div class="comp-c-tools-sharemsg-items">
				<div class="comp-c-tools-sharemsg-item" @click="shareMsgClike('shareMsgOneByOne')">逐条发送</div>
				<div class="comp-c-tools-sharemsg-item" style="background-color: #22cbe2;" @click="shareMsgClike('shareMsgMerge')">合并发送</div>
				<div class="comp-c-tools-sharemsg-item" style="background-color: red;" @click="shareMsgCancel">取消</div>
			</div>
		</div>
		<div class="comp-c-tools-location-box" v-else-if="currentTools == 'location'">
			<position-comp @map-call="mapCall($event)" @close-circle-remind="currentTools = ''"></position-comp>
		</div>
		<div class="comp-c-tools-aite-box" v-else-if="currentTools == 'aite'">
			<cluster-member :chatId="chatId" :cwxid="cwxid" @cluster-member-call="clusterMemberCall(($event))"></cluster-member>
		</div>
		<div class="comp-c-tools-red-packet-box" v-else-if="currentTools == 'redPacket'">
			<red-packet @rp-call="mapCall($event)" @close-circle-remind="currentTools = ''" :chatId="chatId"></red-packet>
		</div>
	</div>
</template>

<script>
	import Emoji from './Emoji.vue'
	import OssImgUploader from './uploader/OssImgUploader.vue'
	import {getLocalConfig} from '../functions/Common.js'
	import PositionComp from './PositionComp.vue'
	import ClusterMember from './ClusterMember.vue'
	import RedPacket from './RedPacket.vue'
	
	export default{
		 name: 'ChatTools',
		 components:{
			 Emoji,
			 OssImgUploader,
			 PositionComp,
			 ClusterMember,
			 RedPacket
		 },
		 props:{
			 isFocus:{
				 default:0
			 },
			 chatType:{
				default:1
			 },
			 chatId:{
				default:0
			 },
			 cwxid:{
				default:''
			 },
			 toolsList:{
				type:Array,
				default:function(){
					return ['emoji','image','file','video','audio','history','fans_transfer','circle','order','location','shareMsg','game','customer_expansion','aite','order2','redPacket']
				}
			 }
		 },
		 data(){
			 return {
				currentTools:'',
				uploadPic:[],
				uploadVideo:[],
				uploadFile:[],
				plugList:["order","game","customer_expansion",'order2','redPacket']
			 }
		 },
		 methods:{
			 // 判断item是否显示
			 isShow(val){
				 // 群聊和个人聊天中的显隐判断
				 let denyPlug = ["aite"]
				 if(this.chatType != 1){
					denyPlug = ["order","game","customer_expansion","fans_transfer","redPacket"]
				 }
				 if(denyPlug.indexOf(val) !== -1){
				 	 return false
				 }
				 // 插件中的显隐判断-根据配置
				 if(this.plugList.indexOf(val) !== -1){
					 if(val == 'order'){
						 let orderPlug = getLocalConfig('orderPlug')
						 if(orderPlug != 1){
						 	return false
						 }	
					 }else if(val == 'game'){
						 let gamePlug = getLocalConfig('gamePlug')
						 if(gamePlug != 1){
						 	return false
						 }	
					 }else if(val == 'customer_expansion'){
						 let customer_expansion_plug = getLocalConfig('customer_expansion_plug')
						 if(customer_expansion_plug != 1){
						 	return false
						 }	
					 }else if(val == 'order2'){
						 let order2_plug = getLocalConfig('order2_plug')
						 if(order2_plug != 1){
						 	return false
						 }	
					 }else if(val == 'redPacket'){
						 let redPacket = getLocalConfig('redPacket')
						 if(redPacket != 1){
						 	return false
						 }	
					 }
				 }
				 // 整体的显隐判断-根据组件参数
				 return this.toolsList.indexOf(val) !== -1
			 },
			 
			 // 工具栏点击
			 toolsClick(val){
				 this.uploadPic = []
				 this.uploadVideo = []
				 this.uploadFile = []
				 if(val == 'circle'){
					 layui.use(['layer','form'],function(){
					 	let layer = layui.layer
					 	 layer.msg('开发中，敬请期待。。。',{icon:5});
					 })
					 return false
				 }else{
					 if(val !== this.currentTools){
						 this.currentTools = val
					 }else{
						 this.currentTools = ''
					 }
					 this.$emit('chat-tool-button-call',val)
				 } 
			 },
			 
			 // 表情回调
			 emojiCall(emoji){
				 this.$emit('chat-tool-call',{
					 type: 'emoji',
					 data: emoji
				 })
			 },
			 
			 // 监听文件上传回调
			 ossUploadCall(data,type){
				 if(type === 'image'){
					 this.uploadPic = data
				 }else if(type === 'video'){
					 this.uploadVideo = data
				 }else if(type === 'file' || type === 'audio'){
					 this.uploadFile = data
					 if(data.length !== 0){
						 this.currentTools = ''
					 }					 
				 }
				 this.$emit('chat-tool-call',{
					 type: type,
					 data: data
				 })
			 },
			 
			 // 消息转发按钮点击-逐条发送，合并发送
			 shareMsgClike(val){
				 if(val === 'shareMsgMerge'){
					 CHAT_LAYER.msg('功能开发中')
					 return
				 }
				 this.$emit('chat-tool-button-call',val)
			 },
			 
			 // 取消多选发送
			 shareMsgCancel(){
				 this.currentTools = ''
				 this.$emit('chat-tool-button-call','shareMsgCancel')
			 },
			 
			 // 监听地图选择
			 mapCall(data){
				 let content = '名称：'+data.title+'<br/>';
				 content += '地址：'+data.address;
				 let _this = this
				 CHAT_LAYER.open({
					 title: '位置确认！',
					 content :content,
					 btn: ['确认发送','重新选择'],
					 yes: function(index, layero){
						 CHAT_LAYER.close(index)
						_this.currentTools = ''
						_this.$emit('chat-tool-call',{
							 type: 'position',
							 data: data
						})
					 },btn2: function(index, layero){
						// 啥都不做
					 },
					 cancel: function(){
						// // 啥都不做
					}
				 });
			 },
			 
			 // 监听群成员点击回调
			 clusterMemberCall(data){
				 this.$emit('chat-tool-call',{
				 	 type: 'clusterMember',
				 	 data: data
				 })
			 }
		 },
		 watch:{
			 isFocus(nVal){
				 if(nVal == 1){
					 this.currentTools = ''
				 }
			 }
		 }
	}
</script>

<style>
	.comp-c-tools{
		width: 100%;
		height: 50px;
		position: relative;
		padding: 0 20px;
		box-sizing: border-box;
	}
	.comp-c-tools .comp-c-tools-container{
		width: 100%;
		height: 50px;
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
	}
	.comp-c-tools-container .comp-c-tools-items{
		flex-grow: 1;
		width: 0;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
	}
	.comp-c-tools-items .comp-c-tools-item{
		width: 24px;
		height: 24px;
		padding: 13px 10px;
	}
	.comp-c-tools-container .comp-c-tools-other{
		width: 100px;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: flex-end;
		flex-wrap: nowrap;
	}
	.comp-c-tools-other .comp-c-tools-o-item{
		width: 24px;
		height: 24px;
		padding: 13px 10px;
	}
	.comp-c-tools-item span,.comp-c-tools-o-item span{
		display: block;
		width: 24px;
		height: 24px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		cursor: pointer;
	}
	.comp-c-tools-emoji{
		background-image: url(../assets/img/comp-c-tools-emoji.png);
	}
	.comp-c-tools-image{
		background-image: url(../assets/img/comp-c-tools-image.png);
	}
	.comp-c-tools-file{
		background-image: url(../assets/img/comp-c-tools-file.png);
	}
	.comp-c-tools-video{
		background-image: url(../assets/img/comp-c-tools-video.png);
	}
	.comp-c-tools-audio{
		background-image: url(../assets/img/comp-c-tools-audio.png);
		background-size: 22px 22px !important;
	}
	.comp-c-tools-history{
		background-image: url(../assets/img/comp-c-tools-history.png);
		background-size: 22px 22px !important;
	}
	.comp-c-tools-order{
		background-image: url(../assets/img/order.png);
		background-size: 20px auto !important;
	}
	.comp-c-tools-share{
		background-image: url(../assets/img/comp-c-tools-share.png);
		background-size: 22px 22px !important;
	}
	.comp-c-tools-circle{
		background-image: url(../assets/img/comp-c-tools-circle.png);
		background-size: 22px 22px !important;
	}
	.comp-c-tools-sharemsg{
		background-image: url(../assets/img/comp-c-tools-share-msg.png);
	}
	.comp-c-tools-location{
		background-image: url(../assets/img/comp-c-tools-location.png);
		background-size: 26px auto !important;
	}
	.comp-c-tools-game{
		background-image: url(../assets/img/comp-c-tools-game.png);
	}
	.comp-c-tools-customer-expansion{
		background-image: url(../assets/img/comp-c-tools-customer-expansion.png);
	}
	.comp-c-tools-aite{
		background-image: url(../assets/img/comp-c-tools-aite.png);
	}
	.comp-c-tools-redpacket{
		background-image: url(../assets/img/comp-c-tools-redpacket.png);
	}
	.comp-c-tools .comp-c-tools-emoji-box{
		position: absolute;
		width: 80%;
		max-width: 500px;
		height: 220px;
		bottom: 48px;
		left: 26px;
	}
	.comp-c-tools .comp-c-tools-image-box{
		position: absolute;
		width: 80%;
		max-width: 556px;
		height: auto;
		bottom: 48px;
		left: 68px;
		background-color: #efefef;
		border-radius: 2px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
	}
	.comp-c-tools-image-box::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #efefef;
		position: absolute;
		bottom: -7px;
		left: 10px;
		transform: rotateZ(45deg);
	}
	.comp-c-tools .comp-c-tools-video-box{
		position: absolute;
		width: 80%;
		max-width: 500px;
		max-height: 350px;
		bottom: 48px;
		left: 68px;
		background-color: #efefef;
		border-radius: 2px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
	}
	.comp-c-tools-video-box::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #efefef;
		position: absolute;
		bottom: -7px;
		left: 54px;
		transform: rotateZ(45deg);
	}
	.comp-c-tools .comp-c-tools-file-box{
		position: absolute;
		width: 80%;
		max-width: 500px;
		max-height: 350px;
		bottom: 48px;
		left: 68px;
		background-color: #efefef;
		border-radius: 2px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
	}
	.comp-c-tools-file-box::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #efefef;
		position: absolute;
		bottom: -7px;
		left: 100px;
		transform: rotateZ(45deg);
	}
	.comp-c-tools .comp-c-tools-audio-box{
		position: absolute;
		width: 80%;
		max-width: 200px;
		max-height: 350px;
		bottom: 48px;
		left: 118px;
		background-color: #efefef;
		border-radius: 2px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
	}
	.comp-c-tools-audio-box::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #efefef;
		position: absolute;
		bottom: -7px;
		left: 94px;
		transform: rotateZ(45deg);
	}
	.comp-c-tools-sharemsg-box{
		position: absolute;
		width: 80%;
		max-width: 200px;
		max-height: 350px;
		bottom: 46px;
		left: 207px;
		background-color: #efefef;
		border-radius: 2px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
	}
	.comp-c-tools-sharemsg-box::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #efefef;
		position: absolute;
		bottom: -7px;
		left: 94px;
		transform: rotateZ(45deg);
	}
	.comp-c-tools-sharemsg-box .comp-c-tools-sharemsg-items{
		padding: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.comp-c-tools-sharemsg-items .comp-c-tools-sharemsg-item{
		margin: 0 2px;
		background-color: #009E94;
		color: #FFFFFF;
		padding: 2px 4px;
		border-radius: 2px;
		cursor: pointer;
		user-select: none;
	}
	.comp-c-tools .comp-c-tools-location-box{
		position: absolute;
		width: 80%;
		max-width: 600px;
		height: 400px;
		bottom: 48px;
		left: 26px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
		background-color: #efefef;
		border-radius: 2px;
		padding: 10px;	
	}
	.comp-c-tools-location-box::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #efefef;
		position: absolute;
		bottom: -7px;
		left: 318px;
		transform: rotateZ(45deg);
	}
	.comp-c-tools .comp-c-tools-aite-box{
		position: absolute;
		width: 80%;
		max-width: 300px;	
		height: 200px;
		bottom: 48px;
		left: 120px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
		background-color: #efefef;
		border-radius: 2px;
		padding: 10px;	
	}
	.comp-c-tools-aite-box::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #efefef;
		position: absolute;
		bottom: -7px;
		left: 268px;
		transform: rotateZ(45deg);
	}
	.comp-c-tools .comp-c-tools-red-packet-box{
		position: absolute;
		width: 80%;
		max-width: 600px;
		height: auto;
		bottom: 48px;
		left: 26px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
		background-color: #efefef;
		border-radius: 2px;
		padding: 10px;	
	}
	.comp-c-tools-red-packet-box::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #efefef;
		position: absolute;
		bottom: -7px;
		left: 361px;
		transform: rotateZ(45deg);
	}
</style>
